<template>
    <div class="home">
      <ActivityXComponents msg="小米活动线报专属页面"/>
    </div>
  </template>

  <script lang="ts">
  import { defineComponent } from 'vue'
  import ActivityXComponents from '@/components/ActivityXComponents.vue' // @ is an alias to /src

  export default defineComponent({
    name: 'activityXPage',
    components: {
      ActivityXComponents
    }
  })
  </script>
